export default {"src":"/_next/static/media/crystal-ball-op.82751f97.gif","height":360,"width":360,"blurWidth":0,"blurHeight":0};